import { ReactComponent as EmptyState } from '@bechtel/client-assets/dist/images/empty-state-weld-dashboard.svg';
import { Box, Heading, Separator, SeparatorType, Text } from '@bechtel/gds';
import { Trans } from '@lingui/macro';
import { isEmpty, map } from 'lodash';
import { FC } from 'react';
import { WeldItemDetailsProps } from './types';

export const WeldItemDetails: FC<WeldItemDetailsProps> = ({ weld }) => {
  const { sections } = weld;

  return (
    <Box flexDirection={{ sm: 'column' }} style={{ overflowY: 'auto' }} data-testid="weld-item-details">
      {isEmpty(sections) ? (
        <Box
          flexDirection={{ sm: 'column' }}
          alignItems={{ sm: 'center' }}
          py={{ sm: '900' }}
          style={{ overflow: 'hidden' }}
          gap={{ sm: '550' }}
        >
          <EmptyState />
          <Text color="grey.1000" weight="600" family="graphik">
            <Trans>No Details Found.</Trans>
          </Text>
        </Box>
      ) : (
        map(sections, (item, index: number) => (
          <Box flexDirection={{ sm: 'column' }} key={index}>
            <Box p={{ sm: '600' }} flexDirection={{ sm: 'column' }}>
              <Heading color="grey.1000" size="600" weight="600">
                {item.title}
              </Heading>
              {item.fields &&
                item.fields.length &&
                map(item.fields, (field, i: number) => (
                  <Box key={i} mt={{ sm: i === 0 ? '500' : '400' }} pt={{ sm: '200' }}>
                    <Text size="400" color="grey.1000" weight="600" family="graphik">
                      {field.name}:&nbsp;
                    </Text>
                    <Text color="grey.1000" size="400" weight="400" family="graphik">
                      {field.value}
                    </Text>
                  </Box>
                ))}
            </Box>
            {index !== sections.length - 1 && (
              <Separator type={SeparatorType.HORIZONTAL} spacing="000" color="grey.300" />
            )}
          </Box>
        ))
      )}
    </Box>
  );
};
